<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>{{ $route.meta.description }}</b>
						</h3>
					</div>
					<div class="box-body">
						<form style="width:100%" method="POST" @submit.prevent="atualizarSenha" ref="usuario">
							<div class='row'>
								<div class="col-sm-4">
									<div :class="{'form-group': true, 'has-error':errors.has('senha-atual') }">
										<label for="usuario">Senha Atual:</label>
										<input class="form-control" name="senha-atual" type="password" v-model="dados.old_password" v-validate="'required'">
										<span v-show="errors.has('senha-atual')" class="help-block">{{ errors.first('senha-atual') }}</span>
									</div>
								</div>

								<div class="col-sm-4">
									<div :class="{'form-group': true, 'has-error':errors.has('senha') }">
										<label for="senha">Nova Senha:</label>
										<input class="form-control" name="senha" type="password" v-model="dados.password" v-validate="'required'">
										<span v-show="errors.has('senha')" class="help-block">{{ errors.first('senha') }}</span>
									</div>
								</div>

								<div class="col-sm-4">
									<div :class="{'form-group': true, 'has-error':errors.has('confirmacaoSenha') }">
										<label for="confirmacaoSenha">Redigite a Nova Senha:</label>
										<input class="form-control" name="confirmacaoSenha" type="password" v-model="confirmacaoSenha" v-validate="{required:true, is:dados.password}">
										<span v-show="errors.has('confirmacaoSenha')" class="help-block">{{ errors.first('confirmacaoSenha') }}</span>
									</div>
								</div>
							</div>
							<div class="box-footer text-right">
								<router-link tag="a" to="/" class="btn btn-default"><span class="fa fa-times"></span> Cancelar</router-link>
								<button class="btn btn-primary" type="submit"><span class="fa fa-check"></span> Salvar</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from "axios"

export default {
	name: "FormAlterarSenha",
	components: {
	},
	data () {
		return {
			dados: {
				old_password: "",
				password: ""
			},
			confirmacaoSenha: ""
		};
	},
	methods: {
		atualizarSenha () {
			this.$validator.validateAll().then(result => {
				if (result) {
					axios.post(`${this.$store.state.serverURI}/api/usuario/updatePassword/` + this.$store.state.user.id, this.dados, this.$store.getters.getHeaderAuth)
						.then(response => {
							this.logout();
						})
						.catch((error) => {
							this.$store.commit('SET_ALERT_MESSAGE', error.response.data.message);
							this.$store.commit('SHOW_ALERT_ERROR');
							console.log(error)
						});
				}
			});
		}
	}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// formAlterarSenha.vue?378462e4